<template>
  <GsSecTitle :title="title" />
</template>
<script>
import GsSecTitle from '@/components/GsSecTitle/index.vue'
export default {
  name: 'TitleTool',
  components: { GsSecTitle },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
